import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTechnical = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "technical",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		id: "Path_12499",
		"data-name": "Path 12499",
		d: "M0,0H24V24H0Z",
		fill: "none"
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_12500",
		"data-name": "Path 12500",
		d: "M16.362,12l3.577,2.018a1,1,0,0,1,.37,1.38l-1.163,1.969a1,1,0,0,1-1.352.362l-3.612-2.038V20a1,1,0,0,1-1,1H10.82a1,1,0,0,1-1-1V15.691L6.208,17.729a1,1,0,0,1-1.352-.362L3.693,15.4a1,1,0,0,1,.37-1.38L7.638,12,4.061,9.982a1,1,0,0,1-.37-1.38L4.854,6.633a1,1,0,0,1,1.352-.362L9.818,8.309V4a1,1,0,0,1,1-1H13.18a1,1,0,0,1,1,1V8.309l3.612-2.038a1,1,0,0,1,1.352.362L20.307,8.6a1,1,0,0,1-.37,1.38L16.362,12Z",
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5
	})]
});
export default SvgTechnical;
